import { render, staticRenderFns } from "./PortalQuestionnaires.vue?vue&type=template&id=9248b414&scoped=true&"
import script from "./PortalQuestionnaires.vue?vue&type=script&setup=true&lang=js&"
export * from "./PortalQuestionnaires.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PortalQuestionnaires.vue?vue&type=style&index=0&id=9248b414&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9248b414",
  null
  
)

export default component.exports